import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Verificar se o elemento root existe
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('❌ Elemento root não encontrado!');
  document.body.innerHTML = '<div style="padding: 20px; font-family: Arial; color: red;"><h1>Erro: Elemento root não encontrado</h1><p>O elemento com id "root" não existe no HTML.</p></div>';
} else {
  try {
    console.log('✅ Inicializando aplicação React...');
    const root = createRoot(rootElement);
    root.render(<App />);
    console.log('✅ Aplicação React renderizada com sucesso!');
  } catch (error) {
    console.error('❌ Erro ao renderizar aplicação:', error);
    rootElement.innerHTML = `
      <div style="padding: 20px; font-family: Arial;">
        <h1 style="color: red;">Erro ao carregar aplicação</h1>
        <p>Erro: ${error instanceof Error ? error.message : String(error)}</p>
        <p>Verifique o console do navegador (F12) para mais detalhes.</p>
      </div>
    `;
  }
}
